<ng-container *ngFor="let item of items">
    <div class="text-white" 
        [ngClass]="item?.alignment" 
        [style.padding-top.px]="item?.padding"
        [style.padding-bottom.px]="item?.padding" 
        *ngIf="item?.type == 'HEADING'" 
        [innerHTML]="item?.content">
    </div>

    <div class="text-white">
        <div class="d-block mx-auto font-size-16" style="max-width: 700px;"
            [ngClass]="item?.alignment" 
            [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" 
            *ngIf="item?.type == 'TEXTAREA'" 
        >
            {{ item?.content }}
        </div>
    </div>

    <div class="text-white"
        [ngClass]="item?.alignment" 
        [style.padding-top.px]="item?.padding"
        [style.padding-bottom.px]="item?.padding" 
        *ngIf="item?.type == 'BUTTON'" 
    >
        <button type="button" class="btn btn-primary font-size-16">
            {{ item?.content }}
        </button>
    </div>
</ng-container>